import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FingerprintConfigurationBiometricActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Biometric/BiometricBrowser")
	}

	render() {
		return (
			<Activity 
				name="FingerprintConfigurationBiometric"
				RenderedComponent={this.RenderedComponent}
				context="FingerprintConfigurationBiometric"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FingerprintConfigurationBiometricActivity)
